import { render, staticRenderFns } from "./RecebimentoDadosNivel2Agrupado.vue?vue&type=template&id=05714264"
import script from "./RecebimentoDadosNivel2Agrupado.vue?vue&type=script&lang=js"
export * from "./RecebimentoDadosNivel2Agrupado.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDadosNivel2Agrupado.vue?vue&type=style&index=0&id=05714264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports